import Api from '@/modules/core/api/api.ts';
import { ManagerAdapter } from '@/modules/counterparty/adapters/manager.adapter.ts';
import { ManagerEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { ManagerDto } from '@/modules/counterparty/dto/manager.dto.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';

export class ManagerApi {
  static async getList(signal: AbortSignal) {
    const response: ItemsDto<ManagerDto> = await Api.post(
      ManagerEndPoint.GetList,
      RequestUtil.orderBy('ФИО', Direction.Asc),
      signal
    );
    return ManagerAdapter.mapList(response);
  }
}
